<template>
  <div>
    <v-dialog v-model="valueProxy" max-width="900">
      <v-card v-if="showAction">
        <v-card-title style="align-items: center">
          Booking
          <v-spacer />
          <v-btn @click="close" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-0 pl-4">
          <v-row>
            <v-col :cols="12" :sm="6" :md="4">
              <v-btn
                class="called-customer full-width mb-5"
                large
                @click="markCalledCustomerForBookingConfirmation"
                :disabled="disable"
                >Called customer confirm booking
              </v-btn>
              <v-btn
                v-if="!isClinicStaff"
                class="full-width mb-5"
                large
                @click="selectAction('editSeat')"
                :disabled="disable"
                >Mark Arrived
              </v-btn>
              <!-- <v-btn
                v-if="!isClinicStaff"
                class="full-width mb-5"
                large
                @click="markLate"
                :disabled="disable"
                >Mark Late
              </v-btn>
              <v-btn
                v-if="!isClinicStaff"
                class="full-width mb-5"
                large
                @click="markAbsent"
                :disabled="disable"
                >Mark Absent
              </v-btn> -->
              <v-btn
                v-if="!isClinicStaff"
                class="full-width mb-5"
                large
                @click="selectAction('changeTimeSchedule')"
                :disabled="disable"
                >Change Time Schedule
              </v-btn>

              <v-btn
                class="full-width mb-5"
                large
                :disabled="disable"
                @click="selectAction('remarks')"
                >Remarks
              </v-btn>
            </v-col>
            <v-col :cols="12" :sm="6" :md="4">
              <v-btn
                v-if="!isClinicStaff"
                class="full-width mb-5"
                large
                @click="selectAction('change')"
                :disabled="disable"
                >Change Therapist
              </v-btn>
              <v-btn
                v-if="!isClinicStaff"
                class="full-width mb-5"
                large
                @click="selectAction('assistant')"
                :disabled="disable"
                >Add Assistant Therapist
              </v-btn>
              <v-btn
                class="full-width mb-5"
                color="success"
                large
                @click="invoiceDialog = !invoiceDialog"
              >
                View Invoice
              </v-btn>
              <v-btn
                v-if="!isClinicStaff"
                class="full-width mb-5"
                color="danger"
                large
                :disabled="disable"
                @click="selectAction('cancelBooking')"
                >Cancel Booking
              </v-btn>
            </v-col>
            <v-col :cols="12" :sm="6" :md="4">
              <div class="mt-3 mt-md-0">
                <v-btn :color="toggle ? 'red' : null" icon @click="updateHeart">
                  <v-icon>mdi-heart</v-icon>
                </v-btn>
                <span>{{ this.profile && this.profile.name }}</span>
                <h3 v-if="isAdmin" class="mb-0">QR code for Customer to scan login:</h3>
                <div
                  v-if="isAdmin"
                  style="position: relative; overflow: hidden; width: 100%; padding-top: 100%"
                  ref="canvasRef"
                >
                  <qrcode-vue
                    v-if="qrcode"
                    :value="qrcode"
                    :size="canvasWidth"
                    level="H"
                    style="position: absolute; top: 0; left: 0; bottom: 0; right: 0"
                  />
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
      <CancelBookingDialog
        :id="id"
        v-if="showCancelBooking"
        :action="action"
        @close="close"
        @update="x => $emit('update', x)"
        @create="x => $emit('create', x)"
        @cancel="x => $emit('cancel', x)"
      />
      <ChangeMasterDialog
        :id="id"
        v-if="showChangeMaster"
        :action="action"
        @close="close"
        @update="x => $emit('update', x)"
        @create="x => $emit('create', x)"
        @cancel="x => $emit('cancel', x)"
      />
      <RearrangeTimetableDialog
        :selectedDate="selectedDate"
        @close="close"
        @update="x => $emit('update', x)"
        @create="x => $emit('create', x)"
        @cancel="x => $emit('cancel', x)"
        v-if="showTImeSchedule"
        :id="id"
        :timeStart="timeStart"
        :timeEnd="timeEnd"
        :duration="model.time.duration"
      />
      <RemarksDialog v-if="showRemarks" @close="close" :id="id" @update="x => $emit('update', x)" />
      <v-dialog v-model="showSeatEditDialog" max-width="600px" v-if="model">
        <v-card>
          <v-card-title style="align-items: center"
            >Edit Seat No.
            <v-spacer />
            <v-btn @click="close" icon>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text style="padding-bottom: 0; padding-top: 20px">
            <v-text-field
              v-model="localTimeTable.Seat"
              placeholder="Set Seat No"
              label="Seat No"
              outlined
            />
          </v-card-text>
          <v-card-actions class="d-flex justify-space-between">
            <v-btn @click="actionCancel"> Cancel</v-btn>
            <v-btn @click="promptSaveTimeTable"> Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>
    <v-dialog v-model="invoiceDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <!-- <invoice
        @close="invoiceDialog = false"
        :id="id"
        @update="x => $emit('update', x)"
        @cancel="x => $emit('cancel', x)"
      /> -->
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api';
import { patchProfile, readProfile, readProfileByMaster } from '@/api/auth/membership';
import {
  cancelBooking,
  markLate,
  markStatus,
  markCalledCustomerForBookingConfirmation,
} from '@/api/bookings';
import { crudDelete, crudUpdate } from '@/api/crud';
import { readTimeTables } from '@/api/timetable';
import ChangeMasterDialog from '@/components/Timetable/ChangeMasterDialog';
import RearrangeTimetableDialog from '@/components/Timetable/RearrangeTimetableDialog';
import QrcodeVue from 'qrcode.vue';
import CancelBookingDialog from '@/components/Timetable/CancelBookingDialog';
import { createLoginToken } from '@/api/auth/sso';
import { getOid } from '@/services/utils';
import RemarksDialog from '@/components/Timetable/RemarksDialog';
import { mapGetters } from 'vuex';

export default {
  name: 'EventCellAction',
  model: {
    prop: 'show',
    event: 'update:show',
  },
  components: {
    RemarksDialog,
    CancelBookingDialog,
    RearrangeTimetableDialog,
    QrcodeVue,
    ChangeMasterDialog,
  },
  props: {
    show: Boolean,
    id: String,
    selectedDate: {},
    timeStart: { h: Number, m: Number },
    timeEnd: { h: Number, m: Number },
  },

  data() {
    return {
      localTimeTable: {
        Seat: null,
      },
      model: null,
      showAction: true,
      showRemarks: false,
      showCancelBooking: false,
      showChangeMaster: false,
      showAddAssistMaster: false,
      showBookingDetails: false,
      showTImeSchedule: false,
      action: null,
      invoiceDialog: false,
      toggle: null,
      profile: null,
      qrcode: null,
      showSeatEditDialog: false,
    };
  },
  methods: {
    selectAction(action) {
      switch (action) {
        case 'change':
          this.action = 'change';
          this.showAction = false;
          this.showChangeMaster = true;
          break;
        case 'assistant':
          this.action = 'assistant';
          this.showAction = false;
          this.showChangeMaster = true;
          break;
        case 'changeTimeSchedule':
          this.showAction = false;
          this.showTImeSchedule = true;
          break;
        case 'cancelBooking':
          this.action = 'cancelled';
          this.showAction = false;
          this.showCancelBooking = true;
          break;
        case 'editSeat':
          this.showAction = false;
          this.showSeatEditDialog = true;
          break;
        case 'remarks':
          this.action = 'remarks';
          this.showAction = false;
          this.showRemarks = true;
          break;
      }
    },
    async updateHeart() {
      this.toggle = !this.toggle;
      await patchProfile(api, this.profile._id, { metadata: { heart: this.toggle } });
      this.$emit('update', this.id);
    },
    async reload() {
      this.model = await readTimeTables(api, this.id, { populate: 'booking' });
      this.profile = this.isAdmin
        ? await readProfile(api, this.model._client)
        : await readProfileByMaster(api, this.model._client);
      this.toggle = this.profile.metadata.heart;
      if (this.isAdmin) {
        const token = (await createLoginToken(api, getOid(this.profile))).token;
        this.qrcode =
          location.origin + '/go?url=/record/' + getOid(this.model.booking) + '&token=' + token;
      }
    },
    actionCancel() {
      this.showSeatEditDialog = false;
    },
    async promptSaveTimeTable() {
      const { Seat } = this.localTimeTable;
      let payload = {
        seat: Seat,
      };
      try {
        await crudUpdate(api, 'rml/admin/timetables', this.model._id, payload);
        await markStatus(api, getOid(this.model.booking), '1$arrived');
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Mark Arrive & Update Success',
          type: 'success',
          color: 'success',
        });
        await this.reload();
        this.$emit('update', this.model._id);
        // this.showSeatEditDialog = false;
        this.valueProxy = false;
      } catch (e) {}
    },
    close() {
      this.valueProxy = false;
    },
    async markArrive() {
      try {
        await markStatus(api, getOid(this.model.booking), '1$arrived');
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Mark Arrive',
          type: 'success',
          color: 'success',
        });
        this.$emit('update', this.id);
        this.valueProxy = false;
      } catch (e) {
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: e,
        });
      }
    },
    async markAbsent() {
      try {
        this.$root.$confirm
          .open('Confirm', 'Confirm to mark absent?', { color: 'warning' })
          .then(async confirm => {
            if (confirm) {
              await markStatus(api, getOid(this.model.booking), '98$absent');
              this.$emit('cancel', this.id);
              await this.$store.dispatch('alert/updateAlertMessage', {
                msg: 'Mark Absent',
                type: 'success',
                color: 'success',
              });
              this.valueProxy = false;
            }
          });
      } catch (e) {
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: e,
        });
      }
    },
    async markLate() {
      try {
        await markLate(api, getOid(this.model.booking), true);
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Mark Late',
          type: 'success',
          color: 'success',
        });

        this.valueProxy = false;
      } catch (e) {
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: e,
        });
      }
    },
    async markCalledCustomerForBookingConfirmation() {
      try {
        await markCalledCustomerForBookingConfirmation(api, getOid(this.model.booking), true);
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Called customer confirm booking',
          type: 'success',
          color: 'success',
        });

        this.valueProxy = false;
      } catch (e) {
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: e,
        });
      }
    },
    async cancelBooking() {
      try {
        await cancelBooking(api, getOid(this.model.booking));
        this.$emit('cancel', this.id);
        await crudDelete(api, 'rml/admin/timetables', this.id);
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: 'Booking cancelled',
          type: 'success',
          color: 'success',
        });
        alert('Do you confirm to cancel this booking?');
        this.valueProxy = false;
      } catch (e) {
        await this.$store.dispatch('alert/updateAlertMessage', {
          msg: e,
        });
      }
    },
  },
  computed: {
    ...mapGetters('auth', ['isClinicStaff', 'isAdmin']),
    valueProxy: {
      get() {
        return this.show;
      },
      set(v) {
        this.$emit('update:show', v);
      },
    },
    disable() {
      return (
        this.model?.booking?.status === '99$completed' ||
        this.model?.booking?.status === '98$absent'
      );
    },
    canvasWidth() {
      return this.$refs.canvasRef?.clientWidth || 150;
    },
  },
  watch: {
    valueProxy: {
      immediate: true,
      handler(v) {
        if (v) {
          this.showAction = true;
          this.reload();
        } else {
          this.showRemarks = this.showChangeMaster = this.showAddAssistMaster = this.showTImeSchedule = this.showCancelBooking = false;
        }
      },
    },
  },
};
</script>

<style scoped>
.called-customer {
  font-size: 0.8rem;
}
</style>
